import { render, staticRenderFns } from "./saveAsTemplate.vue?vue&type=template&id=550f9ae0&scoped=true"
import script from "./saveAsTemplate.vue?vue&type=script&lang=js"
export * from "./saveAsTemplate.vue?vue&type=script&lang=js"
import style0 from "./saveAsTemplate.vue?vue&type=style&index=0&id=550f9ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f9ae0",
  null
  
)

export default component.exports